import parse from "html-react-parser";

const parseEditorValue = (value) =>
  String(value).includes("&lt;") ? parse(value).toString() : value;

export default parseEditorValue;
